import { Injectable, Injector, inject, signal } from '@angular/core';
import { WorkflowDraftConfirmationService } from './workflow-draft-confirmation.service';
@Injectable({ providedIn: 'root' })
export class HearingEnrollmentStateService {
  private readonly injector = inject(Injector);
  readonly dirty = signal(false);
  readonly busy = signal(false);
  confirmNavigation(): boolean | Promise<boolean> {
    if (this.busy()) return false;
    if (!this.dirty()) return true;
    return this.injector
      .get(WorkflowDraftConfirmationService)
      .confirm({
        heading: 'Leave hearing setup?',
        message: 'Unsaved hearing setup choices will be lost.',
        confirmText: 'Leave without saving',
        cancelText: 'Stay on page',
      });
  }
}
